export const generateSiteToken = (token: string) => {
    // Get today's date in YYYY-MM-DD format (to match PHP date('Y-m-d'))
    const today = new Date().toISOString().split('T')[0]
    const dateStamp = today.replace(/-/g, '')

    // Create a more complex token by combining the original token with date
    // and apply encoding to make it harder to reproduce
    const combined = `${token}:${dateStamp}:reassurezmoi`
    const base64 = btoa(combined)

    let encoded = ''
    for (let i = 0; i < base64.length; i += 2) {
        if (i + 1 < base64.length) {
            encoded += base64[i + 1] + base64[i]
        } else {
            encoded += base64[i]
        }
    }

    const finalEncoded = encoded
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '.')

    return finalEncoded
}